import { useMemo, type ComponentType } from 'react';
import AgGridWrapper from '@/app/common/components/ag-grid/AgGridWrapper';
import type { PromptExecutionHistoryBrandSummary } from '../../types';
import { promptHistoryBrandsColumnConfig } from '../../config/promptHistoryBrandsColumnConfig';

type AgGridWrapperProps = {
  table_name?: string;
  height?: string;
  columns: unknown[];
  data: unknown[];
  total?: number;
  settings?: Record<string, unknown>;
  otherOptions?: Record<string, unknown>;
};
const TypedAgGridWrapper = AgGridWrapper as ComponentType<AgGridWrapperProps>;

export function PromptHistoryBrandsTable({
  brands,
  totalExecutions,
}: {
  brands: PromptExecutionHistoryBrandSummary[];
  totalExecutions: number;
}) {
  const columns = useMemo(
    () => promptHistoryBrandsColumnConfig({ totalExecutions }),
    [totalExecutions],
  );

  const otherOptions = useMemo(
    () => ({
      getRowStyle: (params: { data?: PromptExecutionHistoryBrandSummary }) =>
        params.data?.relationship === 'you' ? { background: 'rgba(25, 135, 84, 0.08)' } : undefined,
    }),
    [],
  );

  if (!brands.length) {
    return (
      <p className="fs--1 text-500 text-center py-4 mb-0">
        در این بازه برندی برای این پرامپت شناسایی نشد.
      </p>
    );
  }

  return (
    <TypedAgGridWrapper
      table_name="tracker_ai_prompt_history_brands"
      height="240px"
      columns={columns}
      data={brands}
      total={brands.length}
      settings={{ pagination: false, fullscreen: false, sideBar: false, export: { enabled: false } }}
      otherOptions={otherOptions}
    />
  );
}
